<template>
  <main class="font-base-font">
    <navbar-component></navbar-component>
    <router-view v-slot="{ Component }">
      <transition mode="out-in" name="fade">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </main>
</template>

<script lang="ts">
import NavbarComponent from '@/components/util/Navbar.component.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Index-app',
  components: {
    NavbarComponent,
  },
});
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
